var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { AIButton } from '@web/components/layout/AIInsights/AIButton';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import InfoPopUp from '@web/components/layout/InfoPopUp';
import { Widget } from '@web/components/layout/Widget';
import { AvatarGroup } from '@web/components/ui/AvatarGroup';
import { Tooltip } from '@web/components/ui/Tooltip';
import { MEET_USERS_TIMELINE_COLORS } from '@web/config';
import { classNames, getIconByMeetEventAction, groupTimelineEvents, isAiButtonDisabled } from '@web/utility';
import { InsightTypeEnum } from '@workalizer/shared';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
var PERCENT = 100;
export var MeetUsersTimeline = function (_a) {
    var usersActivity = _a.usersActivity, refetch = _a.refetch, durationSeconds = _a.durationSeconds, plannedDurationSeconds = _a.plannedDurationSeconds, meetingStart = _a.meetingStart;
    var t = useTranslation().t;
    var formatTooltip = function (event) {
        var startDate = format(new Date(event.startTime), 'hh:mm a');
        var title = "".concat(t("meetItemDetails.timeline.".concat(event.type)), ": ").concat(event.users.map(function (user) { return user.name || user.email; }).join(', '));
        return "".concat(title, " - ").concat(startDate);
    };
    var events = usersActivity.flatMap(function (userData) {
        return userData.timelineData.map(function (event) { return ({
            type: event.type,
            time: event.time,
            user: userData.user
        }); });
    });
    var groupedEvents = groupTimelineEvents(events, durationSeconds);
    var meetingStartMs = new Date(meetingStart).getTime();
    var actualEndMs = meetingStartMs + durationSeconds * 1000;
    var plannedEndMs = plannedDurationSeconds != null
        ? meetingStartMs + plannedDurationSeconds * 1000
        : null;
    var eventTimes = groupedEvents.flatMap(function (event) { return [
        event.startTime,
        event.endTime
    ]; });
    var timelineStartMs = Math.min.apply(Math, __spreadArray([meetingStartMs], (eventTimes.length ? eventTimes : [meetingStartMs]), false));
    var timelineEndMs = Math.max.apply(Math, __spreadArray([actualEndMs, plannedEndMs !== null && plannedEndMs !== void 0 ? plannedEndMs : actualEndMs], (eventTimes.length ? eventTimes : [actualEndMs]), false));
    var totalDurationMs = Math.max(timelineEndMs - timelineStartMs, 1);
    var toPercent = function (timeMs) {
        return ((timeMs - timelineStartMs) / totalDurationMs) * PERCENT;
    };
    var plannedEndPercent = plannedEndMs != null ? toPercent(plannedEndMs) : null;
    var actualEndPercent = toPercent(actualEndMs);
    var hasOverrun = plannedEndMs != null && actualEndMs > plannedEndMs + 1000;
    var hasEarlyEnd = plannedEndMs != null && actualEndMs < plannedEndMs - 1000;
    var primaryBarEndPercent = hasOverrun
        ? plannedEndPercent
        : actualEndPercent;
    var overrunStartPercent = plannedEndPercent;
    var overrunWidthPercent = hasOverrun && plannedEndPercent != null
        ? actualEndPercent - plannedEndPercent
        : 0;
    var earlyStartPercent = actualEndPercent;
    var earlyWidthPercent = hasEarlyEnd && plannedEndPercent != null
        ? plannedEndPercent - actualEndPercent
        : 0;
    var MIN_LABEL_GAP_PERCENT = 10;
    var CENTER_LABEL_CLAMP_MIN_PERCENT = 12;
    var CENTER_LABEL_CLAMP_MAX_PERCENT = 88;
    var getTimeLabelPosition = function (align, percent) {
        if (align === 'start') {
            return { className: 'left-0 translate-x-0', style: undefined };
        }
        if (align === 'end') {
            return { className: 'left-full -translate-x-full', style: undefined };
        }
        var clampedPercent = Math.min(CENTER_LABEL_CLAMP_MAX_PERCENT, Math.max(CENTER_LABEL_CLAMP_MIN_PERCENT, percent));
        return {
            className: '-translate-x-1/2',
            style: { left: "".concat(clampedPercent, "%") }
        };
    };
    var candidateLabels = __spreadArray(__spreadArray([
        { time: timelineStartMs, key: 'start', align: 'start' }
    ], ((hasOverrun || hasEarlyEnd) && plannedEndMs != null
        ? [{ time: plannedEndMs, key: 'planned', align: 'center' }]
        : []), true), [
        { time: timelineEndMs, key: 'end', align: 'end' }
    ], false);
    var timeLabels = candidateLabels.reduce(function (labels, label) {
        var percent = toPercent(label.time);
        var tooClose = labels.some(function (existing) {
            return Math.abs(toPercent(existing.time) - percent) < MIN_LABEL_GAP_PERCENT;
        });
        if (!tooClose) {
            labels.push(label);
        }
        return labels;
    }, []);
    return (_jsx(Widget, __assign({ title: _jsxs("span", __assign({ className: "inline-flex items-center" }, { children: [t('meetItemDetails.meetUsersTimeline'), _jsx(InfoPopUp, __assign({ text: t('widgetTitleDescriptions.itemDetails.meetUsersTimeline'), classes: "w-5 h-5 ml-4 my-auto", tooltipClasses: "max-w-[350px] z-50 !text-sm !font-normal", id: "meetUsersTimelineTooltip", place: "bottom" }, { children: _jsx(InformationCircleIcon, {}) }))] })), titleClassName: "mb-8", className: "py-2 sm:px-6 lg:pl-2 lg:pr-2", titleAction: _jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx(ExportMenu, { fileName: t('meetItemDetails.meetUsersTimeline'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, events.map(function (event) { return ({
                                    Time: format(new Date(event.time), 'hh:mm a'),
                                    Event: t("meetItemDetails.timeline.".concat(event.type)),
                                    User: event.user.name || event.user.email
                                }); })];
                        });
                    }); }, disabled: isAiButtonDisabled(usersActivity) }), _jsx(AIButton, { insightsData: usersActivity, insightType: InsightTypeEnum.meetUsersTimeline, refetch: refetch })] })), titleActionClassName: "self-start" }, { children: _jsxs("div", __assign({ className: "min-w-0 py-2 pt-10 pb-4" }, { children: [_jsxs("div", __assign({ className: "relative h-10 px-4 sm:px-3" }, { children: [_jsxs("div", __assign({ className: "absolute left-0 right-0 h-8 rounded-md overflow-hidden bg-gray-100", style: {
                                top: '50%',
                                transform: 'translateY(-50%)'
                            } }, { children: [_jsx("div", { className: "absolute top-0 bottom-0 left-0 bg-gray-200", style: { width: "".concat(Math.max(primaryBarEndPercent, 0), "%") } }), hasOverrun && overrunStartPercent != null && (_jsx("div", { className: "absolute top-0 bottom-0 bg-gray-500", style: {
                                        left: "".concat(overrunStartPercent, "%"),
                                        width: "".concat(Math.max(overrunWidthPercent, 0), "%")
                                    }, title: t('meetItemDetails.timeline.overrun') })), hasEarlyEnd && (_jsx("div", { className: "absolute top-0 bottom-0 bg-sky-200", style: {
                                        left: "".concat(earlyStartPercent, "%"),
                                        width: "".concat(Math.max(earlyWidthPercent, 0), "%")
                                    }, title: t('meetItemDetails.timeline.remainingPlanned') }))] })), plannedEndPercent != null && (hasOverrun || hasEarlyEnd) && (_jsx("div", { className: "absolute top-[-4px] bottom-[-4px] w-px border-l border-dashed border-gray-400 z-10", style: { left: "".concat(plannedEndPercent, "%") } })), groupedEvents.map(function (event) {
                            var startPercent = toPercent(event.startTime);
                            var Icon = getIconByMeetEventAction(event.type);
                            return (_jsx("div", __assign({ className: "absolute z-20", style: {
                                    left: "".concat(startPercent, "%"),
                                    top: '50%',
                                    transform: 'translate(-50%, -50%)'
                                } }, { children: _jsxs("div", __assign({ className: "relative flex flex-col items-center" }, { children: [_jsx("div", __assign({ className: "absolute bottom-full mb-2 left-1/2 -translate-x-1/2" }, { children: _jsx(AvatarGroup, { users: event.users.slice(0, 3) }) })), _jsx(Tooltip, __assign({ content: formatTooltip(event), place: "bottom", style: { zIndex: 200 } }, { children: _jsx("div", __assign({ className: classNames('h-8 w-8 flex items-center justify-center rounded-full shadow-sm ring-2 ring-white', MEET_USERS_TIMELINE_COLORS[event.type] || 'bg-gray-500 hover:bg-gray-600') }, { children: Icon ? _jsx(Icon, { className: "w-4 h-4 text-white" }) : null })) }))] })) }), "".concat(event.startTime, "-").concat(event.type, "-").concat(event.users.map(function (u) { return u.id; }).join('-'))));
                        })] })), _jsx("div", __assign({ className: "relative mt-2 h-5 min-w-0 overflow-x-hidden px-4 text-xs text-gray-600 sm:px-3 sm:text-sm" }, { children: timeLabels.map(function (label) {
                        var percent = toPercent(label.time);
                        var _a = getTimeLabelPosition(label.align, percent), positionClassName = _a.className, positionStyle = _a.style;
                        return (_jsx("span", __assign({ className: classNames('absolute top-0 max-w-[45%] truncate whitespace-nowrap', positionClassName, label.align === 'start' && 'text-left', label.align === 'end' && 'text-right', label.align === 'center' && 'text-center'), style: positionStyle }, { children: format(new Date(label.time), 'hh:mm a') }), "".concat(label.key, "-").concat(label.time)));
                    }) }))] })) })));
};
